/**
 * Filters a phone number to digits and the allowed formatting characters (`+ ( ) space -`),
 * capped at 16 characters. Pure — lifted from the legacy PhoneNumberField.
 */
export function formatPhoneNumber(value = ''): string {
    return (value || '').replace(/(^[+])?[^\d()\s-]*/gi, '$1').replace(/(.{0,16}).*/, '$1')
}
